module.exports = __webpack_public_path__ + "media/assets/images/letter-blue-dbee99b24131d5eb4b26975ff1dcf2a9.svg";